import { Td } from "@chakra-ui/react";
import { useHistory } from "react-router-dom";

import { useGetFriendlyUrl } from "utils/hooks/useGetFriendlyUrl";

import { ChakraText } from "components/ChakraText";

import { ExpiredAppointmentActionButtons } from "./ExpiredAppointmentActionButtons";
import { IAppointmentDetails } from "../../../../application/types/IAppointmentDetails";
import { AppointmentRowContainer } from "../../components/AppointmentRowContainer";
import { AppointmentStartDate } from "../../components/AppointmentStartDate";
import { AppointmentStatusTag } from "../../../AppointmentStatusTag";

interface IProps {
  appointment: IAppointmentDetails;
}

const ExpiredAppointmentRow = ({ appointment }: IProps) => {
  const { push } = useHistory();
  const { friendlyUrl } = useGetFriendlyUrl();

  return (
    <AppointmentRowContainer
      onClick={() =>
        push(
          `/e-rezerwacja/${friendlyUrl}/uzytkownik/historyczne-wizyty/${appointment.appointmentId}`
        )
      }
      id={`expired-appointment-${appointment.appointmentId}-row`}
    >
      <Td maxW={"150px"} wordWrap="break-word">
        <AppointmentStartDate appointmentStartDate={appointment.startDate} />
      </Td>
      <Td maxW={"150px"} wordWrap="break-word">
        <ChakraText isTruncated>{appointment.orgUnitFullName}</ChakraText>
      </Td>
      <Td maxW={"150px"} wordWrap="break-word">
        <ChakraText isTruncated>{appointment.queueName}</ChakraText>
      </Td>
      <Td maxW={"150px"} wordWrap="break-word">
        <ChakraText isTruncated>{appointment.groupName}</ChakraText>
      </Td>
      <Td maxW={"150px"} wordWrap="break-word">
        <AppointmentStatusTag status={appointment.status} />
      </Td>
      <Td>
        <ExpiredAppointmentActionButtons appointment={appointment} />
      </Td>
    </AppointmentRowContainer>
  );
};

export { ExpiredAppointmentRow };
